import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { VOLUNTEER_CREATION } from "../API_LIST";
import { toastMaker, validateEmail } from "../utils/utility";
import matrimonyInstance from "../utils/axios";

export default function CreateVolunteer(props) {
	const navigate = useNavigate();
	const [volunteerData, setVolunteerData] = useState({
		first_name: "",
		last_name: "",
		gender: "",
		mobile_number: "",
		email: "",
		password: "",
	});

	const handleChange = (e) => {
		const { value, pattern } = e.target;
		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);

			if (!result) return;
		}
		setVolunteerData((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};

	const createVolunteer = async (e) => {
		e.preventDefault();
		let data = volunteerData;
		matrimonyInstance
			.post(VOLUNTEER_CREATION, data)
			.then((response) => {
				toastMaker("New Volunteer Created", "success");
				props.closeModal();
			})
			.catch((error) => {
				console.log("error");
				toastMaker(error, "error");
			});
	};

	return (
		<div className="create-volunteer">
			<h4 className="text-center mb-20">Create Volunteer</h4>
			<form onSubmit={createVolunteer}>
				<div className="create-volunteer-responsive-width">
					<div className="form-group mb-20">
						<label className="mb-10">First Name *</label>
						<input
							type="text"
							className="form-control"
							name="first_name"
							pattern="^[a-zA-Z ]+$"
							value={volunteerData.first_name}
							onChange={(e) => handleChange(e)}
						/>
					</div>
					<div className="form-group mb-20">
						<label className="mb-10">Last Name *</label>
						<input
							type="text"
							className="form-control"
							name="last_name"
							pattern="^[a-zA-Z ]+$"
							value={volunteerData.last_name}
							onChange={handleChange}
						/>
					</div>
					<div className="mb-25">
						<label for="gender">Gender *</label>
						<select
							name="gender"
							value={volunteerData.gender}
							onChange={handleChange}
							id="gender"
							className="form-select rounded-1 mt-15"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="male">Male</option>
							<option value="female">Female</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label className="mb-10">Mobile Number *</label>
						<input
							type="tel"
							className="form-control"
							name="mobile_number"
							pattern="^\+?\d{1,15}$"
							maxLength={15}
							value={volunteerData.mobile_number}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label className="mb-10">Email *</label>
						<input
							type="email"
							className="form-control"
							name="email"
							value={volunteerData.email}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label className="mb-10">Password *</label>
						<input
							type="password"
							className="form-control"
							name="password"
							maxLength={20}
							value={volunteerData.password}
							onChange={handleChange}
						/>
					</div>
				</div>
				<button
					type="submit"
					className="btn mt-20 mb-50"
					onClick={createVolunteer}
				>
					Submit
				</button>
			</form>
		</div>
	);
}
